document.addEventListener('DOMContentLoaded', () => {
    const chartSection = document.querySelector('.section.chart');
    let chartsRendered = false;

    function renderCharts() {
        if (chartsRendered) return;
        chartsRendered = true;

        // Doughnut Chart
        const ctx1 = document.getElementById('myChart1')?.getContext('2d');
        if (ctx1) {
            new Chart(ctx1, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [10, 50, 80, 100],
                        backgroundColor: ['#B49CF4', '#FF9F1C', '#10C8CD', '#4A77BB'],
                        hoverOffset: 4
                    }]
                },
                options: { responsive: true, maintainAspectRatio: false }
            });
        }

        // Line Chart
        const ctx2 = document.getElementById('myChart2')?.getContext('2d');
        if (ctx2) {
            new Chart(ctx2, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
                    datasets: [
                        { label: 'Roshan', data: [2, 7, 15, 17, 17], borderColor: '#4A77BB', tension: 0.1 },
                        { label: 'Alessia', data: [0, 3, 6, 11, 11], borderColor: '#10C8CD', tension: 0.1 }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { position: 'top' }
                    }
                }
            });
        }

        // Polar Area Chart
        const ctx3 = document.getElementById('myChart3')?.getContext('2d');
        if (ctx3) {
            new Chart(ctx3, {
                type: 'polarArea',
                data: {
                    labels: ['Outer', 'Inner'],
                    datasets: [
                        { data: [45, 50], backgroundColor: ['#5D89DF', '#10C8CD'], borderWidth: 0 }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        r: {
                            beginAtZero: true,
                            ticks: { display: false },
                            grid: { circular: true }
                        }
                    },
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    }
                }
            });
        }
    }

    // Use IntersectionObserver to trigger chart rendering on scroll
    if ('IntersectionObserver' in window && chartSection) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    renderCharts();
                    obs.disconnect(); // only run once
                }
            });
        }, {
            root: null,
            threshold: 0.6 // adjust this for earlier or later triggering
        });

        observer.observe(chartSection);
    } else {
        // Fallback for old browsers
        renderCharts();
    }
});
